import React from 'react';
import { Link } from 'react-router-dom';
import Price from "./price"
const MainInfo = {
    pageTitle: {
        chinese: '关于PMS',
        english: 'ABOUT PMS'
    },
    crumb: {
        home: {
            name: {
                "chinese": "首页",
                "english": "Home"
            },
            url: '/'
        },
        about: {
            name: {
                "chinese": "关于",
                "english": "About"
            },
            url: '/about'
        },
        text: {
            "chinese": "正文",
            "english": "Text"
        }
    },
    contentTitle: {
        chinese: '公司介绍',
        english: 'About us'
    },
    contentData: {
        chinese: ['广州派敏斯速递有限公司（简称PMS速递）创立于2015年，是一家涵盖运输、电子商务和商业运作等一系列全面服务的速递企业，主营业务包括：美国专线、英国专线、邮政邮政小包服务等服务。',
            '派敏斯速递有限公司总部设立在佛山，并且在广州、美国、英国、德国等其他地方有着丰富的运输网络资源，除此之外，我司与UPS/DHL/Fedex等国际物流商建立了深远的合作关系，我司恪守品行道德和职业操守的最高标准，尽最大能力满足客户和社会的需求，凭着优质的服务、良好的信誉、优势的价格、舱位的保证及丰富的操作经验，赢得了较好的市场口碑。我们基于物流，并且集仓储、运输、配送于一体，跨区域、网络化、信息化、智能化、具有供应链管理能力的综合性能力。',
            '此外，我司还配备专业、优秀、服务能力强的物流团队，我们始终秉承着“专业、高效、诚信、耐心”的理念，用最好的服务满足客户的需求，全程跟踪包裹信息，为客户建立“多快好省”的运输途径，不断拓展多样化、个性化的新业务，不断扩充社会网络资源，尽量做到“安全、优质、性价比高、便捷、迅速”。由于团队的高效工作能力与优质的服务能力，我司的物流服务团队一致获得客户的信任与支持。',
            '派敏斯速递用最优质的国际物流方案，为客户提供最满意，最高效的服务，把企业打造成世界知名物流企业是我司一直以来的目标。'],
        english: ['Guangzhou PINE Express Co., Ltd. (PMS Express) was founded in 2015, which is a logistics company covering transport, e-commerce and commercial operations and a series of full-service .The main business includes US Logistics direct line, UK Logistics direct line and China Postal packet services and other services.',
            'The PMS Express’ headquarter is located in Foshan,Guangdong Province and We also established a wealth of transportation network resources in Guangzhou, United States, UK, Germany and other overseas countries. In addition, our company has established a long-term cooperation relationship with UPS / DHL / Fedex and other international logistics companies. Our company scrupulously abide by the highest standards of moral and professional conduction and we do our best to meet the needs of customers and society with a good reputation service, advantages of prices, shipping accommodation guarantee and a wealth of operational experience in the market. We are based on logistics, with the ability of warehousing, transportation, and distribution in one. The character of our service abilities are across-regional, network, information, intelligent. All of these comprehensive abilities with the supply chain management capabilities.',
            'In addition, our company also equipped with professional, excellent, service ability of the logistics team. We consist the moral of “Professional, Efficiency, Integrity, Patient” We try our best to meet the needs of customers, packages tracking logistics information to establish the route of better, faster and more economically logistics management chain. We also consistent to expand numerous and individual business and enhance our social international resource. We take our effort to achieve the standards of “safety, high-quality , convince and quickness ”. Our logistics team also won a good reputation in the market due to our good service and work efficiency.',
            'PMS Express provide the most efficient service for our customers because of our excellent logistics programs, and to create a world-renowned logistics enterprises is the goal which we are consistent to do.']
    },
    banner: {
        chinese: '派你所想，永不延退，把握现在，成就非凡未来。',
        english: 'Dispatch what you think and never ever delay. Seize present and to co-create a bright future.'
    },
    pageFooter: {
        title: {
            chinese: '核心优势',
            english: 'Advantages'
        },
        introduce: {
            chinese: '我司业务广泛，涵盖仓储、运输、配送于一体, 适应时代发展，致力发展智能物流。美国专线，英国专线，邮政小包等服务，我们要求时效严格，全程跟踪客户的包裹信息，根据客户不同的需求，准确掌握客户信息，服务优先，并且价格合理。服务多元化，网络资源丰富，具有优秀、专业的服务团队为客户提供服务与咨询。',
            english: 'Our company divided to develop intelligence logistics, For adapting to the social development in the future, we have the extensive business covered warehousing, transportation, and distribution. We are serious to our delivery time and trace the packages’ information for our clients. According to the different needs of customers, we can grasp information of customers accurately, providing service priority, and using the price appropriately. Our company also equipped with professional, excellent, service ability of the logistics team.'
        },
        usa: {
            name: {
                chinese: '美国专线：',
                english: 'US Logistics Service: '
            },
            info: {
                chinese: '具备智能选仓系统，为客户量身定做适合的运输途径。',
                english: 'with an intelligent sorting system, establish the appropriate transport routes for customers. '
            }
        },
        uk: {
            name: {
                chinese: '英国专线：',
                english: 'UK Logistics Service: '
            },
            info: {
                chinese: '与英国皇家邮政建立长期的合作关系，全程跟踪包裹提供优先服务。',
                english: 'Establishing a deep relationship with Roy mail, we provides priority services :full-tracking package. '
            }
        }
    }
}
export default class About extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { language } = this.props;
        let currentRoute = this.props.location.pathname
        if (currentRoute == "/about/price") {
           
            return (
                <Price parent={this}></Price>
            )
        } else {
            return (
                <div className="pms-container pms-about">
                    <div className="page-banner">
                        <img src={require('../assets/image/about-banner.png')} alt="" />
                        <p className="pms-common-title"><span></span> {MainInfo.pageTitle[language]}</p>
                    </div>
                    <div className="page-crumbs">
                        <span><Link to="/">{MainInfo.crumb.home.name[language]}</Link> &gt;</span>
                        <span>{MainInfo.crumb.about.name[language]} &gt;</span>
                        <span>{MainInfo.crumb.text[language]}</span>
                    </div>
                    <h1 className="page-head-title">
                        <span className="sub-logo">
                            <img src={require('../assets/image/logo.png')} alt="" />
                        </span>
                        {MainInfo.contentTitle[language]}
                    </h1>
                    <div className="page-container">
                        <p className="page-container-message"></p>
                        <p className="page-container-message"></p>
                        <p className="page-container-message"></p>
                        <p className="page-container-message"></p>
                        <div className="page-container-image">
                            <img src={require('../assets/image/home-mid.png')} alt="" />
                            <p>{MainInfo.banner[language]}</p>
                        </div>
                        <div className="about-title">
                            <h4>
                                <span className="about-title-image">
                                    <img src={require('../assets/image/about-image1.png')} alt="" />
                                </span>
                                <span>{MainInfo.pageFooter.title[language]}</span>
                            </h4>
                            <p>{MainInfo.pageFooter.introduce[language]}</p>
                            <div className="clear">
                                <div className="col-xs-1"><span className="about-title-image">
                                    <img src={require('../assets/image/about-image2.png')} alt="" />
                                </span></div>
                                <div className="col-xs-11">
                                    <p>{MainInfo.pageFooter.usa.name[language]}</p>
                                    <p>{MainInfo.pageFooter.usa.info[language]}</p>
                                </div>
                            </div>
                            <div className="clear">
                                <div className="col-xs-1"><span className="about-title-image">
                                    <img src={require('../assets/image/about-image3.png')} alt="" />
                                </span></div>
                                <div className="col-xs-11">
                                    <p>{MainInfo.pageFooter.uk.name[language]}</p>
                                    <p>{MainInfo.pageFooter.uk.info[language]}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

    }
}



// WEBPACK FOOTER //
// ./public/views/about.js